"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var ErrorMessageDisplayComponent = (function () {
    function ErrorMessageDisplayComponent() {
    }
    ErrorMessageDisplayComponent.prototype.ngAfterContentInit = function () {
        this.formattedMessage = this.message ? this.message.replace(/\\n/gi, '<br />') : '';
    };
    return ErrorMessageDisplayComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ErrorMessageDisplayComponent.prototype, "message", void 0);
ErrorMessageDisplayComponent = __decorate([
    core_1.Component({
        selector: 'error-message-display',
        template: "<div class=\"error-wrapper\">     <div class=\"error-icon\">         <span class=\"fa fa-2x fa-exclamation-circle text-danger\"></span>     </div>     <div class=\"error-message\" [innerHTML]=\"formattedMessage\"></div> </div>",
        styles: ["\n        .error-icon {\n            display: inline-block;\n            margin-left: -30px;\n            margin-right: 20px;\n            vertical-align: top;\n\n            .fa-exclamation-circle {\n                color: @alert-danger-text;\n                display: inline;\n            }\n        }\n\n        .error-message {\n            display: inline-block;\n            width:90%;\n        }\n\n        .error-wrapper {\n            margin-left: 24px;\n        }\n    "]
    }),
    __metadata("design:paramtypes", [])
], ErrorMessageDisplayComponent);
exports.ErrorMessageDisplayComponent = ErrorMessageDisplayComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/error-message-display/error-message-display.component.js